import React from "react";

import { useTranslation } from "react-i18next";

import { CorrectScore } from "@data-types/sport-stats/SportStatsTypes";
import RecentGames from "../RecentGames";

export default function CorrectScoreStatistics(props: {
	homeTeam: CorrectScore["data"];
	awayTeam: CorrectScore["data"];
}) {
	const { t } = useTranslation();

	if (props.homeTeam?.frequentScorelines == null) {
		console.error("Home team frequentScorelines is null.");
	}

	if (props.awayTeam?.frequentScorelines == null) {
		console.error("Away team frequentScorelines is null.");
	}

	return (
		<>
			<RecentGames
				homeTeamEventCount={props.homeTeam?.eventCount}
				awayTeamEventCount={props.awayTeam?.eventCount}
			/>

			{props.homeTeam?.frequentScorelines ? (
				<div className="card card--raised card--raised--framed card--stats">
					<div className="card__header card--stats__header">
						<div className="card__title card__title--base card--stats__heading">
							{t(
								"EVENT.STATISTICS.BETTING_TYPE_STATS.FREQUENT_SCORELINES"
							)}
						</div>
						<div className="card--stats__subtitle">
							{t("OFFER.COMPETITORS.HOME")}
						</div>
					</div>
					<div className="card--stats__body">
						{props.homeTeam?.frequentScorelines.map((data) => (
							<CorrectScoreStatisticsItem
								key={Math.random()}
								data={data}
								isHome
							/>
						))}
					</div>
				</div>
			) : null}

			{props.awayTeam?.frequentScorelines ? (
				<div className="card card--raised card--raised--framed card--stats">
					<div className="card__header card--stats__header">
						<div className="card__title card__title--base card--stats__heading">
							{t(
								"EVENT.STATISTICS.BETTING_TYPE_STATS.FREQUENT_SCORELINES"
							)}
						</div>
						<div className="card--stats__subtitle">
							{t("EVENT.STATISTICS.AWAY_TEAM")}
						</div>
					</div>
					<div className="card--stats__body">
						{props.awayTeam?.frequentScorelines.map((data) => (
							<CorrectScoreStatisticsItem
								key={Math.random()}
								data={data}
								isHome={false}
							/>
						))}
					</div>
				</div>
			) : null}
		</>
	);
}

const CorrectScoreStatisticsItem = ({
	data,
	max,
	isHome,
}: {
	data?: {
		awayScore?: number;
		frequency?: number;
		homeScore?: number;
	};
	max?: number;
	isHome?: boolean;
}) => {
	return (
		<div className="card--stats__section">
			<div className="card--stats__row">
				<div className="card--stats__col card--stats__col--left">
					<div className="card--stats__label">
						{data?.homeScore} : {data?.awayScore}
					</div>
				</div>
				<div className="card--stats__col card--stats__col--right">
					<div
						className={`card--stats__value ${
							isHome ? "is-home" : "is-away"
						}`}
					>
						{data?.frequency || 0}%
					</div>
				</div>
			</div>
			<div className="card--stats__row">
				<div className="card--stats__col card--stats__col--middle">
					<div
						className={`chart chart--left ${
							isHome ? "is-home" : "is-away"
						}`}
					>
						<progress
							id="chartHome"
							className="chart__progress"
							value={data?.frequency || 0}
							max={max || 100}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
